document.addEventListener("DOMContentLoaded", function () {
  const closeButtons = document.querySelectorAll(".close-pay-later-popup");
  const openButtons = document.querySelectorAll(".open-pay-later-popup");
  const popupWrapper = document.querySelector(".pay-later-popup-wrp");

  // Function to open the popup
  function openPopup() {
    popupWrapper.classList.add("active");
    document.body.style.overflow = "hidden"; // disable page scroll
  }

  // Function to close the popup
  function closePopup() {
    popupWrapper.classList.remove("active");
    document.body.style.overflow = ""; // enable page scroll
  }

  // Add click event to all close buttons
  closeButtons.forEach((button) => {
    button.addEventListener("click", closePopup);
  });

  // Add click event to all open buttons
  openButtons.forEach((button) => {
    button.addEventListener("click", openPopup);
  });
});
